import { version } from './version';

import { IEnvironment } from '@aa/common';

export const environment: IEnvironment = {
  production: true,
  version: version,
  selfServDomain: null // injected into window.appConfig
};
